export const PREDOMINANT_DEGREE_OPTIONS = {
  NOT_CLASSIFIED: 'Not classified',
  PREDOMINANTLY_CERTIFICATE_DEGREE_GRANTING: 'Predominantly certificate-degree granting',
  PREDOMINANTLY_ASSOCIATES_DEGREE_GRANTING: "Predominantly associate's-degree granting",
  PREDOMINANTLY_BACHELORS_DEGREE_GRANTING: "Predominantly bachelor's-degree granting",
  ENTIRELY_GRADUATE_DEGREE_GRANTING: 'Entirely graduate-degree granting',
} as const;

export type PredominantDegree =
  (typeof PREDOMINANT_DEGREE_OPTIONS)[keyof typeof PREDOMINANT_DEGREE_OPTIONS];

export const SCORECARD_REGION_OPTIONS = {
  U_S_SERVICE_SCHOOLS: 'U.S. Service Schools',
  NEW_ENGLAND: 'New England',
  MID_EAST: 'Mid East',
  GREAT_LAKES: 'Great Lakes',
  PLAINS: 'Plains',
  SOUTHEAST: 'Southeast',
  SOUTHWEST: 'Southwest',
} as const;

export type ScorecardRegion =
  (typeof SCORECARD_REGION_OPTIONS)[keyof typeof SCORECARD_REGION_OPTIONS];

export const BACKRS_REGION_OPTIONS = {
  NORTHEAST: 'Northeast',
  MIDWEST: 'Midwest',
  SOUTHEAST: 'Southeast',
  WEST: 'West',
} as const;

export type BackrsRegion = (typeof BACKRS_REGION_OPTIONS)[keyof typeof BACKRS_REGION_OPTIONS];

export type College = Readonly<{
  id: number;
  ipeds_id: number;
  school_name: string;
  url: string;
  predominant_degree?: PredominantDegree;
  carnegie_classification?: string;
  endowment?: number;
  city?: string;
  state?: string;
  admission_rate?: number;
  satvr25?: number;
  satvr50?: number;
  satvr75?: number;

  satmt25?: number;
  satmt50?: number;
  satmt75?: number;

  actcm50?: number;
  actcm25?: number;
  actcm75?: number;

  latitude?: number;
  longitude?: number;
  median_grad_debt?: number;
  grad_threshold_6_years?: number;
  undergrad_enrollment?: number;
  student_faculty_ratio?: number;
  median_completion_rate?: number;
  median_cost?: number;
  ranking?: number;
  scorecard_region?: ScorecardRegion;
  backrs_region?: BackrsRegion;
  gpa_25?: number;
  gpa_50?: number;
  gpa_75?: number;
  open_admission?: boolean;
  created_at: Date;
  updated_at: Date;
  category?: string;
  type?: string;
  setting?: string;
  early_decision?: boolean;
  early_decision_deadline?: Date;
  application_deadline?: Date;
  application_url?: string;
  gpa_mean?: number;
  gpa_mean_weighted?: number;
  net_price_calculator_url?: string;
  net_price_income_level_0_30000?: number;
  net_price_income_level_30001_48000?: number;
  net_price_income_level_48001_75000?: number;
  net_price_income_level_75001_110000?: number;
  net_price_income_level_110001_plus?: number;
  tuition_in_state?: number;
  tuition_out_of_state?: number;
  room_and_board?: number;
  fees?: number;
  average_financial_aid?: number;
  est_total_investment?: number;
  est_10yr_earning?: number;
  est_14yr_roi?: number;
  return_yr1?: number;
  return_yr2?: number;
  return_yr3?: number;
  return_yr4?: number;
  return_yr5?: number;
  return_yr6?: number;
  return_yr7?: number;
  return_yr8?: number;
  return_yr9?: number;
  return_yr10?: number;
  return_yr11?: number;
  return_yr12?: number;
  return_yr13?: number;
  return_yr14?: number;
  scoop_best_known_for?: string;
  scoop_vibe_check?: string;
  scoop_opportunities_networks?: string;
  description?: string;

  logo_media_id?: number | null;
  logo_media_url?: string | null;
  banner_media_id?: number | null;
  banner_media_url?: string | null;
}>;
